import axios, { AxiosResponse } from 'axios';

import { ActionTypes } from './action-types';

export const loadDataAction = () => (dispatch: any) => {
  axios.get('cv.json')
       .then((response: AxiosResponse) => dispatch({type: ActionTypes.DATA_LOADED, payload: response.data}));
};



// WEBPACK FOOTER //
// ./src/store/actions/load-data.action.ts